"use strict";
/*
 * Created on 09 10 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var PriceWithValidity_1 = require("../model/PriceWithValidity");

var PriceWithValidityConverter_1 = require("./PriceWithValidityConverter");
/**
 * <p>Implementation of {@link PriceWithValidityConverter}.</p>
 *
 * @author Jaroslav Sevcik
 */


var PriceWithValidityConverterImpl =
/*#__PURE__*/
function (_PriceWithValidityCon) {
  _inherits(PriceWithValidityConverterImpl, _PriceWithValidityCon);

  function PriceWithValidityConverterImpl() {
    _classCallCheck(this, PriceWithValidityConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(PriceWithValidityConverterImpl).apply(this, arguments));
  }

  _createClass(PriceWithValidityConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new PriceWithValidity_1.PriceWithValidity(conversions.asObject(source, 'value', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'valueRounded', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObject(source, 'validFrom', function (v) {
        return conversions.toDate(v);
      }), conversions.asObjectOpt(source, 'validTo', function (v) {
        return conversions.toDate(v);
      }));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var result = {};
      Object.assign(result, {
        value: conversions.fromBigNumber(source.value),
        valueRounded: conversions.asObjectOpt(source, 'valueRounded', function (v) {
          return conversions.fromDate(v);
        }),
        validFrom: conversions.fromDate(source.validFrom),
        validTo: conversions.asObjectOpt(source, 'validTo', function (v) {
          return conversions.fromDate(v);
        })
      });
      return result;
    }
  }]);

  return PriceWithValidityConverterImpl;
}(PriceWithValidityConverter_1.PriceWithValidityConverter);

exports.PriceWithValidityConverterImpl = PriceWithValidityConverterImpl;